export const SEARCH_ENGINE_ICONS = {
  airport:
    'https://cdn.naviparking.com/digital_parking/img/search-engine/park-and-fly.svg',
  location:
    'https://cdn.naviparking.com/digital_parking/img/search-engine/location.svg',
  clock:
    'https://cdn.naviparking.com/digital_parking/img/search-engine/clock.svg',
  deleteRecentSearch:
    'https://cdn.naviparking.com/digital_parking/img/search-engine/delete-recent-search.svg',
  closeModal:
    'https://cdn.naviparking.com/digital_parking/img/search-engine/close-modal.svg'
} as const

export type SearchEngineIconKey = keyof typeof SEARCH_ENGINE_ICONS

export enum IconType {
  AIRPORT = 'AIRPORT',
  LOCATION = 'LOCATION',
  RECENT_SEARCH = 'RECENT_SEARCH'
}

export const getSearchIconByType = (type: IconType): string => {
  switch (type) {
    case IconType.AIRPORT:
      return SEARCH_ENGINE_ICONS.airport
    case IconType.LOCATION:
      return SEARCH_ENGINE_ICONS.location
    case IconType.RECENT_SEARCH:
      return SEARCH_ENGINE_ICONS.clock
    default:
      return SEARCH_ENGINE_ICONS.location
  }
}
